export default __webpack_public_path__ + "static/media/p65.8bb937aa.jpg";